import React, {useCallback, useEffect} from "react";
import {useParams} from "react-router-dom";
import {PublicTransitLayerEntityName} from "../../../../api/entities/replancity_PublicTransitLine";
import {useTypedSelector} from "../../../../redux/Hooks/storeSelectors";
import {selectMapLayerIdByEntityName} from "../../../../redux/selectors/selectors";
import EntityEditor from "../../../../components/Entities/EntityEditor";
import EntityManagerCleaner from "../../../../components/Entities/EntityManagerCleaner";
import {isErrorResponse, isUuidString} from "../../../../utils/utils";
import {flewToPoint} from "../../../../redux/map/map-reducer";
import {useDispatch} from "react-redux";
import {getFeatureCenter} from "../../../../utils/mapUtils";
import {useMapFeatureLoader} from "../../../../hooks/entites/useMapFeatureLoader";
import {useMapFiltersContext} from "../../../../context/mapFiltersContext";


const StopEdit = () => {
    const stopEntityName = PublicTransitLayerEntityName.STOPS;
    const routesEntityName = PublicTransitLayerEntityName.ROUTES;
    const {stopId} = useParams<any>();
    const stopsLayerId = useTypedSelector((state) => selectMapLayerIdByEntityName(state, PublicTransitLayerEntityName.STOPS));
    const routesLayerId: string = useTypedSelector((state) => selectMapLayerIdByEntityName(state, PublicTransitLayerEntityName.ROUTES));
    const {loadFeature} = useMapFeatureLoader({entityName: stopEntityName});
    const dispatch = useDispatch();

    const {setLayerPaint} = useMapFiltersContext();

    const highlightStop = useCallback((featureStateId: string) => {
        const stopsFeaturesExpression = ['==', ['get', 'featureStateId'], featureStateId];
        setLayerPaint(prevState => ({
            ...prevState,
            [routesLayerId]: {
                'line-width': 1,
                'line-opacity': 0.7,
                'line-color': 'grey'
            },
            [stopsLayerId]: {
                'circle-color': ['case', stopsFeaturesExpression, "#db08e8", 'grey'],
                'circle-opacity': ['case', stopsFeaturesExpression, 1, 0.1],
            }
        }))
    }, [])

    useEffect(() => {
        return () => {
            setLayerPaint(prevState => {
                    const {[routesLayerId]: toRemove1, [stopsLayerId]: toRemove2, ...rest} = prevState;
                    return {
                        ...rest,
                    }
                }
            )
        }
    }, []);

    useEffect(() => {
        void (async function () {
            if (isUuidString(stopId)) {
                const {feature} = await loadFeature({
                    entityId: stopId!,
                    entityName: stopEntityName,
                    findFeatureParent: false
                });

                if (!isErrorResponse(feature)) {
                    const [lng, lat] = getFeatureCenter(feature);
                    if (lng && lat) {
                        dispatch(flewToPoint({lng, lat, zoom: 15}));
                    }

                    highlightStop(feature.properties.featureStateId.toString());
                }
            }
        }());
    }, [stopEntityName, routesEntityName, stopId, stopsLayerId])

    //TODO fix "fly to" and stop highlighting from useTransitStopLoader

    const getUrlOnSaveFn = useCallback((entity: any) => {
        if (!isUuidString(stopId)) {
            return `../`;
        }
    }, [stopId]);

    const onDeleteFn = useCallback(() => '../../', []);

    return (
        <EntityManagerCleaner entityName={stopEntityName}>
            <EntityEditor
                entityId={stopId!}
                entityName={stopEntityName}
                layerId={stopsLayerId}
                presetProperty={'publicTransitPreset'}
                getUrlOnSaveFn={getUrlOnSaveFn}
                getUrlOnDeleteFn={onDeleteFn}
                showDeleteBtn={isUuidString(stopId)}
            />
        </EntityManagerCleaner>
    )
}

export default StopEdit;